<template>
  <div class="flex justify-between bg-gray-300 mt-auto">
    <ClaimNumId
      :is-populated="isPopulated"
      :num-uri-string="numUriString"
      :query-location="queryLocation"
      class="py-6"
    />
    <ToggleFavourite :num-uri-string="numUriString" class="py-6" />
  </div>
</template>

<script>
import ClaimNumId from "@/views/Home/ClaimNumId";
import ToggleFavourite from "@/views/Home/Favourite/Toggle";

export default {
  name: "FooterCard",
  components: {
    ClaimNumId,
    ToggleFavourite,
  },
  props: {
    isPopulated: Boolean,
    numUriString: String,
    queryLocation: String,
  },
};
</script>
